<template>
  <div>
    <div v-if="!success">
      <div class="row">
        <div class="col">
          <TitleForm>Dados da primeira pessoa</TitleForm>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Input
            label="Código de funcionário"
            placeholder="ex.: 589254786"
            v-model="code1"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Input
            label="Nome completo"
            placeholder="ex.: João da Silva"
            v-model="name1"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label>
            <StrongText>Gênero</StrongText>
          </label>
          <div class="group">
            <radio-button label="Feminino" value="Feminino" v-model="gender1" />
            <radio-button label="Masculino" value="Masculino" v-model="gender1" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg">
          <Input
            label="Email"
            placeholder="ex.: joao@site.com"
            v-model="email1"
          />
        </div>
        <div class="col-12 col-lg">
          <Input
            label="Data de nascimento"
            placeholder="ex.: 10/04/1981"
            type="tel"
            v-mask="'##/##/####'"
            v-model="birth1"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label>
            <StrongText>Tamanho da camiseta</StrongText>
          </label>
          <div class="group">
            <radio-button label="P" value="P" v-model="size1" />
            <radio-button label="M" value="M" v-model="size1" />
            <radio-button label="G" value="G" v-model="size1" />
            <radio-button label="GG" value="GG" v-model="size1" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Input
            label="Celular para receber mensagem (Whatsapp)"
            placeholder="ex.: 11 98765 4321"
            type="tel"
            v-mask="['(##) #### ####', '(##) ##### ####']"
            v-model="phone1"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Input
            label="Telefone de Emergência"
            placeholder="ex.: 11 98765 4321"
            type="tel"
            v-mask="['(##) #### ####', '(##) ##### ####']"
            v-model="emergency1"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Input
            label="Se for de carro ao evento, informe a placa do veículo"
            placeholder="ex.: ELV 1555"
            v-mask="'AAA-####'"
            v-model="car1"
          />
        </div>
      </div>
      <div class="row espacoEntreForms">
        <div class="col">
          <TitleForm>Dados da segunda pessoa</TitleForm>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Input
            label="Código de funcionário"
            placeholder="ex.: 589254786"
            v-model="code2"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Input
            label="Nome completo"
            placeholder="ex.: João da Silva"
            v-model="name2"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label>
            <StrongText>Gênero</StrongText>
          </label>
          <div class="group">
            <radio-button label="Feminino" value="Feminino" v-model="gender2" />
            <radio-button label="Masculino" value="Masculino" v-model="gender2" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg">
          <Input
            label="Email"
            placeholder="ex.: joao@site.com"
            v-model="email2"
          />
        </div>
        <div class="col-12 col-lg">
          <Input
            label="Data de nascimento"
            placeholder="ex.: 10/04/1981"
            type="tel"
            v-mask="'##/##/####'"
            v-model="birth2"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label>
            <StrongText>Tamanho da camiseta</StrongText>
          </label>
          <div class="group">
            <radio-button label="P" value="P" v-model="size2" />
            <radio-button label="M" value="M" v-model="size2" />
            <radio-button label="G" value="G" v-model="size2" />
            <radio-button label="GG" value="GG" v-model="size2" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Input
            label="Celular para receber mensagem (Whatsapp)"
            placeholder="ex.: 11 98765 4321"
            type="tel"
            v-mask="['(##) #### ####', '(##) ##### ####']"
            v-model="phone2"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Input
            label="Telefone de Emergência"
            placeholder="ex.: 11 98765 4321"
            type="tel"
            v-mask="['(##) #### ####', '(##) ##### ####']"
            v-model="emergency2"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Input
            label="Se for de carro ao evento, informe a placa do veículo"
            placeholder="ex.: ELV 1555"
            v-mask="'AAA-####'"
            v-model="car2"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label>
            <StrongText>Confirmação da leitura do regulamento:</StrongText>
          </label>
          <div class="group">
            <radio-button label="Lemos e aceitamos o regulamento" :value="true" v-model="regulamento" />
          </div>
        </div>
      </div>
    </div>
    <div class="row text-center">
      <div class="col">
        <span @click="send">
          <Button big :disabled="disabled">Cadastrar</Button>
        </span>
      </div>
    </div>
    <div class="row" v-if="error || success">
      <div class="col">
        <br/>
        <Alert
          error
          v-if="error"
          v-html="error"
        />
        <Alert
          success
          v-if="success"
          v-html="success"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api'
import Alert from '@/components/Alert'
import TitleForm from '@/components/TitleForm'
import Check from '@/components/Check'
import CheckGender from '@/components/CheckGender'
import Input from '@/components/Input'
import Button from '@/components/Button'
import StrongText from '@/components/StrongText'

import RadioButton from '@/components/RadioButton'

export default {
  name: 'RevezamentoInscrevase',
  data: () => ({
    code1: '',
    name1: '',
    email1: '',
    birth1: '',
    size1: '',
    phone1: '',
    emergency1: '',
    gender1: '',
    car1: '',
    code2: '',
    name2: '',
    email2: '',
    birth2: '',
    size2: '',
    phone2: '',
    emergency2: '',
    gender2: '',
    car2: '',
    disabled: false,
    error: false,
    success: false,
    regulamento: false,
  }),
  methods: {
    async send() {

      if(this.disabled)
        return

      this.error = false
      this.success = false
      this.disabled = true

      try {

        let str1 = this.birth1.split('/')
        let str2 = this.birth2.split('/')

        await api.relay({
          code1: this.code1,
          name1: this.name1,
          email1: this.email1,
          birth1: `${str1[2]}-${str1[1]}-${str1[0]}`,
          size1: this.size1,
          phone1: this.phone1,
          emergency1: this.emergency1,
          gender1: this.gender1,
          car1: this.car1,
          code2: this.code2,
          name2: this.name2,
          email2: this.email2,
          birth2: `${str2[2]}-${str2[1]}-${str2[0]}`,
          size2: this.size2,
          phone2: this.phone2,
          emergency2: this.emergency2,
          gender2: this.gender2,
          car2: this.car2,
          regulamento: this.regulamento,
        })

        this.code1 = '',
        this.name1 = '',
        this.email1 = '',
        this.birth1 = '',
        this.size1 = '',
        this.phone1 = '',
        this.emergency1 = '',
        this.gender1 = '',
        this.car1 = '',
        this.code2 = '',
        this.name2 = '',
        this.email2 = '',
        this.birth2 = '',
        this.size2 = '',
        this.phone2 = '',
        this.emergency2 = '',
        this.gender2 = '',
        this.car2 = '',

        this.success = 'Cadastro realizado com sucesso! Esperamos você no evento'

      } catch (response) {

        const error = Object.values(response.response.data.errors)
        this.error = error[0][0]
        setTimeout(() => this.disabled = false, 1000)

      }
    },
  },
  components: {
    CheckGender,
    Input,
    Check,
    Alert,
    Button,
    StrongText,
    RadioButton,
    TitleForm
  }
}
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center
}
.espacoEntreForms {
  margin-top: 40px;
}
.group {
  margin-top: 11px;
  margin-bottom: 60px;
}
</style>
